module.exports = __webpack_public_path__ + "static/media/MenuUnavailable.ab288f2d.png";